import { render, staticRenderFns } from "./CameraSetting.vue?vue&type=template&id=0a044c2b&scoped=true&"
import script from "./CameraSetting.vue?vue&type=script&lang=js&"
export * from "./CameraSetting.vue?vue&type=script&lang=js&"
import style0 from "./CameraSetting.vue?vue&type=style&index=0&id=0a044c2b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a044c2b",
  null
  
)

export default component.exports